import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronDown, Database, LayoutDashboard, LogOut, MessageSquare, Plus, Settings2, Sparkles, X } from "lucide-react";
import { api } from "@/lib/api";

export function Sidebar({ open, history, liveCount, onClose, onNewChat, onOpenAdmin, onAsk }) {
  const recent = useMemo(() => history.slice(0, 6), [history]);
  const openAdmin = () => { onClose(); onOpenAdmin(); };
  const navigate = useNavigate();
  const logout = async () => { try { await api.logout(); } finally { navigate("/login", { replace: true }); } };
  return (
    <aside className={`sidebar ${open ? "sidebar-open" : ""}`} data-testid="sidebar">
      <div className="brand">
        <div className="brand-mark"><Sparkles size={17} /></div>
        <div><strong>GInfomedia AI</strong><span>QUERY HUB</span></div>
        <button className="icon-btn mobile-close" data-testid="close-navigation-button" onClick={onClose}><X size={18} /></button>
      </div>
      <button className="new-chat" data-testid="new-chat-button" onClick={onNewChat}><Plus size={17} /> New conversation</button>
      <div className="side-label">Workspace</div>
      <nav className="nav-list">
        <button className="nav-item active" data-testid="chat-navigation"><MessageSquare size={17} /> Reporting chat</button>
      {/* <button className="nav-item" data-testid="portfolio-navigation"><LayoutDashboard size={17} /> Portfolio overview</button>*/}
        <button className="nav-item" data-testid="data-sources-navigation" onClick={openAdmin}><Database size={17} /> Data sources <span className="nav-badge" data-testid="live-sources-badge">{liveCount} live</span></button>
      </nav>
      <div className="side-label history-label">Recent questions</div>
      <div className="history-list">
        {recent.length ? recent.map((item, i) => (
          <button className="history-item" data-testid={`history-item-${i}`} key={item.chat_id} onClick={() => onAsk(item.question)}>
            <span>{item.question}</span><small>{item.report_type?.replace(" report", "")}</small>
          </button>
        )) : <div className="empty-history">Your recent reports will appear here.</div>}
      </div>
      <div className="sidebar-bottom">
        <button className="nav-item" data-testid="settings-button" onClick={openAdmin}><Settings2 size={17} /> Settings</button>
        <button className="nav-item" data-testid="logout-button" onClick={logout}><LogOut size={17} /> Sign out</button>
        <div className="profile"><div className="avatar">AK</div><div><strong>Admin workspace</strong><span>Single organization</span></div><ChevronDown size={15} /></div>
      </div>
    </aside>
  );
}
